import React, {useEffect, useRef} from 'react';
import {useIsFocused, useNavigation, useRoute} from '@react-navigation/native';
import {middlewareType} from '../../utils/webviewJSBridge';
import {
  WebviewCustomerMemo,
  WebviewCustomerRef,
} from '../../components/WebviewCustomer';
import YouDaoOCRView, {
  YouDaoOCRViewRef,
} from '../AViewComponents/OCRImgView/YouDaoOCRView';
import {RouteProp} from '@react-navigation/core/src/types';
import {RouteParamsList} from '../../router/ParamsList';
import {AIWebviewURL} from '../../env/webviewUrl';
import {logApi} from '../../API/base';
import IntentLauncher, {
  IntentConstant,
} from '@suxueweibo/react-native-intent-launcher';
import Toast from 'react-native-toast-message';
import {AppInfoType} from '../TeacherSelect/TeacherSelect';
import AINativeModules from '../../hooks/AINativeModules';
import {GetHomePageConfigData} from '../../API/newHome';
import {DeviceEventEmitter} from 'react-native';
import {
  hideGlobalLoading,
  showGlobalLoading,
} from '../../components/Loading/GlobalLoading';
type SideItem = {
  text: string;
  routerName?: string;
  appName?: string;
};

type ChatGPTPageProps = {
  urlPath: string;
};

export default function ChatGPTPage(
  props: ChatGPTPageProps,
): React.JSX.Element {
  const navigation = useNavigation();
  const route = useRoute<RouteProp<RouteParamsList, 'ChatGPTTeacher'>>();
  const webviewCustomerRef = useRef<WebviewCustomerRef | null>(null);
  const youDaoOCRViewRef = useRef<YouDaoOCRViewRef>(null);
  const [isWebMounted, setIsWebMounted] = React.useState(false);
  const hasSetMountedRef = useRef(false);
  // 申请录音权限
  // useRecord();
  // 侦测拍照答疑
  useEffect(() => {
    console.log('route.params', route.params);
    if (route.params?.recordId) {
      if (isWebMounted) {
        // 向网页通知，侦测到拍照答疑完成
        webviewCustomerRef.current?.sendMessage({
          eventName: 'takeFinish',
          data: {
            recordId: route.params?.recordId,
          },
        });
        navigation.setParams({recordId: ''});
      }
    } else if (route.params?.editData) {
      if (isWebMounted) {
        // 向网页通知, 侦测到编辑答疑完成
        webviewCustomerRef.current?.sendMessage({
          eventName: 'editDataFinish',
          data: {
            editData: route.params?.editData,
            courseName: route.params?.courseName,
          },
        });
        navigation.setParams({editData: '', courseName: ''});
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route.params, isWebMounted]);
  useEffect(() => {
    // const requestMicrophonePermission = async () => {
    //   try {
    //     const granted = await PermissionsAndroid.request(
    //       PermissionsAndroid.PERMISSIONS.RECORD_AUDIO,
    //       {
    //         title: 'Microphone Permission',
    //         message:
    //           'App needs access to your microphone for speech recognition.',
    //         buttonNeutral: 'Ask Me Later',
    //         buttonNegative: 'Cancel',
    //         buttonPositive: 'OK',
    //       },
    //     );
    //     if (granted === PermissionsAndroid.RESULTS.GRANTED) {
    //       console.log('Microphone permission granted');
    //     } else {
    //       console.log('Microphone permission denied');
    //     }
    //   } catch (err) {
    //     console.warn(err);
    //   }
    // };

    // requestMicrophonePermission();

    // AINativeModules.init();

    const onRecognizingSubscription = AINativeModules.addListener(
      'onRecognizing',
      event => {
        webviewCustomerRef.current?.sendMessage({
          eventName: 'onRecognizing',
          data: event.data,
        });
      },
    );

    const onRecognizedSubscription = AINativeModules.addListener(
      'onRecognized',
      event => {
        webviewCustomerRef.current?.sendMessage({
          eventName: 'onRecognized',
          data: event.data,
        });
      },
    );

    return () => {
      onRecognizingSubscription.remove();
      onRecognizedSubscription.remove();
    };
  }, []);
  const isFocused = useIsFocused();
  useEffect(() => {
    if (!isFocused) {
      // 离开页面
      webviewCustomerRef.current?.sendMessage({
        eventName: 'routeLeave',
        data: '',
      });
    }
  }, [isFocused]);

  const sideMenus: Array<SideItem> = [
    {
      text: 'AI伴学师',
      routerName: 'ChatGPTTeacherSelect',
    },
    {
      text: '作业辅导',
      routerName: 'CmsWebView',
    },
    {
      text: '教学视频',
      routerName: 'VideoExpo',
    },
    {
      text: '我的学案',
      routerName: 'MyLearn',
    },
    {
      text: '个人中心',
      routerName: 'UserCenter',
    },
    {
      text: '学习资源',
      appName: 'weixin',
    },
    {
      text: 'AI备考',
      routerName: 'MyLearnBeikao',
    },
  ];
  const goRoute = (data: GetHomePageConfigData) => {
    console.log(111, data);

    try {
      logApi({
        // @ts-ignore
        useFunction: data.path,
        bizId: '',
      });
    } catch (e) {}

    if (data.clickTo === 1) {
      // @ts-ignore
      navigation.navigate(data.path);
    } else if (data.clickTo === 2) {
      IntentLauncher.startActivity({
        action: 'android.intent.action.MAIN',
        category: 'android.intent.category.LAUNCHER',
        packageName: 'com.jxw.launcher',
        className: 'com.jxw.launcher.ThemeActivity',
        flags: IntentConstant.FLAG_ACTIVITY_NEW_TASK,
      });
      // openAppURL(i.appName);
      console.log(IntentLauncher);
    } else {
      Toast.show({
        type: 'info',
        text1: '近期上线，敬请期待',
      });
    }
  };

  const toGPT = (item: AppInfoType) => {
    if (item.id === '5eaa34d4-38ea-45ee-8bd1-84b06610a98e') {
      // @ts-ignore
      navigation.navigate('ChatGPTAssist');
    } else {
      // @ts-ignore
      navigation.navigate('ChatGPTTeacher');
    }
  };

  const webEventHandle: middlewareType = (eventName, data, _res) => {
    switch (eventName) {
      case 'takePhoto': {
        youDaoOCRViewRef.current?.start();
        break;
      }
      case 'goBack': {
        navigation.goBack();
        break;
      }
      case 'goMenuRoute': {
        goRoute(data);
        break;
      }
      case 'goGPTApp': {
        toGPT(data);
        break;
      }
      case 'openScheduleDrawer': {
        DeviceEventEmitter.emit('openScheduleDrawer');
        break;
      }
      case 'WebMounted': {
        if (!hasSetMountedRef.current) {
          console.log('WebMounted - 首次加载');
          setIsWebMounted(true);
          hasSetMountedRef.current = true;
        }
        hideGlobalLoading();
        break;
      }
      case 'startRecognize': {
        console.log('触发start');
        AINativeModules.startRecognize()
          .then(() => {
            webviewCustomerRef.current?.sendMessage({
              eventName: 'recognizeStarted',
              data: null,
            });
          })
          .catch(error => {
            console.log('Failed to start recognize:', error);
            // webviewCustomerRef.current?.sendMessage({
            //   eventName: 'recognizeError',
            //   data: error.message,
            // });
          });
        break;
      }
      case 'stopRecognize': {
        console.log('触发stop');
        AINativeModules.stopRecognize()
          .then(() => {
            webviewCustomerRef.current?.sendMessage({
              eventName: 'recognizeStopped',
              data: null,
            });
          })
          .catch(error => {
            console.log('Failed to stop recognize:', error);
            // webviewCustomerRef.current?.sendMessage({
            //   eventName: 'recognizeError',
            //   data: error.message,
            // });
          });
        break;
      }
    }
  };
  useEffect(() => {
    console.log('ChatGPTPage 组件加载');
    showGlobalLoading({
      text: '加载中...',
    });
    return () => {
      console.log('ChatGPTPage 组件卸载');
      hasSetMountedRef.current = false;
      hideGlobalLoading();
    };
  }, []);
  const url = `${AIWebviewURL}${props.urlPath}?cmsRecordId=${
    route.params?.cmsRecordId || ''
  }`;

  return (
    <>
      <YouDaoOCRView ref={youDaoOCRViewRef} />
      <WebviewCustomerMemo
        style={{
          height: '100vh',
        }}
        ref={webviewCustomerRef}
        eventHandle={webEventHandle}
        url={url}
        key="webview-customer"
      />
    </>
  );
}
